/* eslint-disable @typescript-eslint/camelcase */
import React from 'react';
import InstalledCountryBody from '../../../shared/installations/InstalledCountryBody';
import { useUser } from '../../../../../hooks/shared/user/useUser';
import CustomerSupportNavBar from '../../../../layouts/customer-support/CustomerSupportNavBar';

const CustomerSupportInstallationsPerCountry = () => {
  const { profile, user } = useUser();
  const { firstName } = profile;
  return (
    <div className="s-layout">
      <main className="s-layout__content col-lg-10 p-0">
        <CustomerSupportNavBar currentPage="Installations Per Country" roleID={user.role_id} position={firstName} />
        <InstalledCountryBody profile={profile} />
      </main>
    </div>
  );
};

export default CustomerSupportInstallationsPerCountry;
